module.exports = __webpack_public_path__ + "img/face8.83f317fa.jpg";